// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2qEWs","title":"BackImages_title__2IvlQ","images":"BackImages_images__3s2XU"};